import { Component, Input, OnInit } from '@angular/core';
import {
  CampaignAccountApiStates,
  CampaignAccountStatus,
} from '../../../../../shared/models/campaign/account-status';

@Component({
  selector: 'app-account-status',
  templateUrl: './account-status.component.html',
  styleUrls: ['./account-status.component.scss'],
  imports: [],
})
export class AccountStatusComponent implements OnInit {
  @Input() status: CampaignAccountStatus;
  @Input() accountState: CampaignAccountApiStates;

  ngOnInit(): void {
    this.setStatusForDisplay();
  }

  setStatusForDisplay(): void {
    switch (this.accountState) {
      case 'ACTIVE':
        this.status = 'success';
        break;
      case 'INACTIVE':
        this.status = 'failed';
        break;
      case 'UNAUTHORIZED':
        this.status = 'failed';
        break;
      case 'PENDING':
        this.status = 'pending';
        break;
    }
  }
}
